export function workTypeLabel(type: string): string {
  if (type === "movie") return "电影";
  if (type === "tv") return "电视剧";
  return "作品";
}

export function formatDate(date: string): string {
  const [year, month, day] = date.split("-");
  if (!year || !month || !day) return date;
  return `${year} 年 ${Number(month)} 月 ${Number(day)} 日`;
}

export function getInitial(name: string): string {
  return name ? name.slice(0, 1) : "?";
}